import React from 'react';
import { connect } from 'react-redux';
import BarChart from '../../reports/barChartReport/BarChartReport';
import DataSnapshot from '../../aylaTimeZone/AylaTimeZone';
import FilterPanel, {
  date_range, oem_id, oem_model, sw_version,
} from '../../filters/filterPanel/FilterPanel';
import ReportPage from '../ReportPage';
import TimeAggregation from '../../filters/timeAggregationFilter/TimeAggregationFilter';
import TitleBar from '../../titleBar/TitleBar';
import {AYLA_ALLOWED_ROLES, GoogleAnalyticsConstants} from '../../../constants';
import {
  activatedDevices, aylaSoftwareVersionOverTime, contractTotalDatapointsTransactions,
  deviceCountByAylaSoftwareVersion, deviceCountByHostSoftwareVersion, devicesOnlineToday,
  hostSoftwareVersionOverTime, listOfOemModels, listOfOems,
  listOfSwVersions, totalDatapoints, userCountByAylaSoftwareVersion,
  userCountByHostSoftwareVersion
} from '../../../services/reportsservice';
import './DeviceSWAnalysisPage.css';
import {logPageViewEvent} from "../../../services/analyticsservice";
import {getErrorReportNames, getReportData} from "../../../helpers/utils";

class DeviceSWAnalysisPage extends ReportPage {
  googleAnalytics() {
    const { logged_in_oem_id } = this.props.presistFilters;
    logPageViewEvent(GoogleAnalyticsConstants.DeviceSWAnalysisPage.title, logged_in_oem_id);
  }
  reports() {
    const filters = this.props.presistFilters;
    const isUsFieldDpMeteringOem = (this.props.presistFilters.region_name === 'US-FIELD'
        && this.us_field_dp_metering_oems.includes(this.props.presistFilters.oem_id));
    const isEuFieldDpMeteringOem = (this.props.presistFilters.region_name === 'EU'
        && this.eu_field_dp_metering_oems.includes(this.props.presistFilters.oem_id));
    const isSharkVpc = (((this.props.presistFilters.region_name === 'US-VPC') || (this.props.presistFilters.region_name === 'EU'))
        && this.props.presistFilters.oem_id === '39a9391a');

    return {
      filters: [
        listOfOemModels(filters),
        listOfSwVersions(filters),
        listOfOems(filters),
      ],
      reports: (isUsFieldDpMeteringOem || isEuFieldDpMeteringOem || isSharkVpc) ? [
        activatedDevices(filters),
        contractTotalDatapointsTransactions(filters),
        devicesOnlineToday(filters),
        aylaSoftwareVersionOverTime(filters),
        userCountByAylaSoftwareVersion(filters),
        deviceCountByAylaSoftwareVersion(filters),
        hostSoftwareVersionOverTime(filters),
        userCountByHostSoftwareVersion(filters),
        deviceCountByHostSoftwareVersion(filters),
        ]
        : [
        activatedDevices(filters),
        totalDatapoints(filters),
        devicesOnlineToday(filters),
        aylaSoftwareVersionOverTime(filters),
        userCountByAylaSoftwareVersion(filters),
        deviceCountByAylaSoftwareVersion(filters),
        hostSoftwareVersionOverTime(filters),
        userCountByHostSoftwareVersion(filters),
        deviceCountByHostSoftwareVersion(filters),
      ],
    };
  }

  reportsDescription = () => [
    aylaSoftwareVersionOverTime(),
    userCountByAylaSoftwareVersion(),
    deviceCountByAylaSoftwareVersion(),
    hostSoftwareVersionOverTime(),
    userCountByHostSoftwareVersion(),
    deviceCountByHostSoftwareVersion(),
  ];

  render() {
    const { fetchData, errors, session } = this.props;
    if(errors.length > 0) getErrorReportNames(errors);

    return (
      <div className="DeviceSWAnalysisPage page">
        <TitleBar title="softwareAnalysis">
          <TimeAggregation value={this.props.presistFilters.aggregate_by} />
          <DataSnapshot snapShot={this.dataSnapshotTime} />
        </TitleBar>
        <div className="pageContent">
          <FilterPanel disabled={fetchData.fetches > 0}
            currentFilters={this.props.presistFilters}
            filters={[
              date_range,
              AYLA_ALLOWED_ROLES.includes(session.role) && oem_id(this.report(listOfOems)),
              oem_model(this.report(listOfOemModels)),
              sw_version(this.report(listOfSwVersions)),
            ]}
          />

          <div>
            <BarChart title="devices.aylaSoftwareVersionOverTime"
              width={this.widthForColumns(2)}
              height={200}
              data={getReportData(this.report(aylaSoftwareVersionOverTime),'Ayla_Module_Version_Updated_Over_Time')}
              description={this.reportDescription(aylaSoftwareVersionOverTime)}
              xLabel={this.props.presistFilters.aggregate_by}
              yLabel="devices"
              skipDetailsTranslation
            />
            <BarChart title="users.countByAylaSoftwareVersion"
              width={this.widthForColumns(2)}
              height={200}
              data={getReportData(this.report(userCountByAylaSoftwareVersion),'User_Count_By_Ayla_Module')}
              description={this.reportDescription(userCountByAylaSoftwareVersion)}
              xLabel="aylaSWVersion"
              yLabel="users"
              skipDetailsTranslation
            />
          </div>
          <div>
            <BarChart title="devices.countByAylaSoftwareVersion"
              width={this.widthForColumns(2)}
              height={200}
              data={getReportData(this.report(deviceCountByAylaSoftwareVersion), 'Device_Count_By_Ayla_Module')}
              xLabel="aylaSWVersion"
              yLabel="devices"
              description={this.reportDescription(deviceCountByAylaSoftwareVersion)}
              skipDetailsTranslation
            />
            <BarChart title="devices.hostSoftwareVersionOverTime"
              width={this.widthForColumns(2)}
              height={200}
              data={getReportData(this.report(hostSoftwareVersionOverTime), 'Host_Module_Version_Updated_Over_Time')}
              xLabel={this.props.presistFilters.aggregate_by}
              yLabel="devices"
              description={this.reportDescription(hostSoftwareVersionOverTime)}
              skipDetailsTranslation
            />
          </div>
          <div>
            <BarChart title="users.countByHostSoftwareVersion"
              width={this.widthForColumns(2)}
              height={200}
              data={getReportData(this.report(userCountByHostSoftwareVersion), 'User_Count_By_Host_SW')}
              xLabel="hostSWVersion"
              yLabel="users"
              description={this.reportDescription(userCountByHostSoftwareVersion)}
              skipDetailsTranslation
            />
            <BarChart title="devices.countByHostSoftwareVersion"
              width={this.widthForColumns(2)}
              height={200}
              data={getReportData(this.report(deviceCountByHostSoftwareVersion), 'Device_Count_By_Host_SW')}
              xLabel="hostSWVersion"
              yLabel="devices"
              description={this.reportDescription(deviceCountByHostSoftwareVersion)}
              skipDetailsTranslation
            />
          </div>

        </div>
      </div>
    );
  }
}

export default connect(state => state)(DeviceSWAnalysisPage);
